
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.475","height":"18.957"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"svg",attrs:{"d":"M5.682 18.953c.667-.184 1.354-.266 2.034-.387q4.527-.809 9.056-1.608c.322-.057.32-.067.1-.326l-5.475-6.523a.544.544 0 01-.105-.614q1.434-3.909 2.848-7.825c.033-.091.033-.237.136-.25.124-.015.152.137.2.225q2.659 4.6 5.313 9.2 2.272 3.937 4.54 7.877c.046.079.094.156.142.233zM0 16.772a18.427 18.427 0 00.963-1.613Q3.508 10.75 6.04 6.334a3.478 3.478 0 01.889-.872q3.127-2.641 6.27-5.264a2.207 2.207 0 00.186-.2h.055a2.287 2.287 0 01-.288.731q-2.7 5.816-5.418 11.627-.991 2.127-1.975 4.258c-.073.157-.146.277-.354.276-1.8-.008-3.6-.008-5.4-.011z"}})])
          )
        }
      }
    